import { useWire } from "~/wire";

export type AuthGateOptions = {
  title: string;
  description?: string;
};

export const useGateActionByAuthenticated = <T extends Array<unknown>, U>(
  options: () => AuthGateOptions,
  action: (...args: T) => U,
  onCancel?: () => void,
) => {
  const wire = useWire();

  const wrappedAction = (...args: T): U | undefined => {
    if (wire.auth.isGuest()) {
      wire.ui.authGate.openModal(options());
      onCancel?.();
      return;
    }
    return action(...args);
  };

  return wrappedAction;
};
